import { useState, useCallback } from 'react';

/**
 * Custom hook for managing toast notifications
 * @param {number} duration - Duration in milliseconds before toast auto-dismisses (default: 3000)
 * @returns {Object} Toast state and showToast function
 */
export function useToast(duration = 3000) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), duration);
  }, [duration]);

  return { toast, showToast };
}
